import type { MotionProps } from 'framer-motion';
import {
  buildHiddenVariant,
  buildVisibleVariant,
} from '@/components/animations';

const visible = buildVisibleVariant();

/*
 * Card Sub Title
 */
const CARD_SUB_TITLE_X_OFFSET = 50;

export const cardSubTitleMotionProps: MotionProps = {
  variants: {
    hidden: buildHiddenVariant({ x: CARD_SUB_TITLE_X_OFFSET }),
    visible,
  },
};

/*
 * Card Description
 */
const CARD_DESCRIPTION_Y_OFFSET = 30;

export const cardDescriptionMotionProps: MotionProps = {
  variants: {
    hidden: buildHiddenVariant({ y: CARD_DESCRIPTION_Y_OFFSET }),
    visible,
  },
};
